import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import URL from '../../../constants/url';
import TopBannerBox from '../../../components/box/TopBannerBox';
import style from './MedicalGuide.module.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import { getCalculateDDay } from '../../../assets/js/comm';
import Skeleton from '@mui/material/Skeleton';

const MedicalGuide = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const navigate = useNavigate();

    // 재택 치료 가이드
    const [homeCareGuideList, setHomeCareGuideList] = useState([]);

    // 토스트메시지 관련 세트
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    // 2. 상태 추가
    const [isLoading, setIsLoading] = useState(true);


    // 화면특수기능렌더 useRef 선언
    const isInitialRender = useRef(true);
    

    /***************
     * 기능부
     **************/


    /**
     * 재택 치료 가이드 조회
     */
    const searchHomeCareGuideList = () => {

        const requestUrl = "/homecare/guide/retrieveUserHomeCareGuideList";

        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const requestBody = {
            usrInfoId: user?.usrInfoId
            , usrHsptlMap: user?.usrHsptlMap
            , cntsTyCd: "A"
        }

        axiosApi.post(requestUrl, requestBody, requestOption)
            .then((res) => {
                const resultData = res.data;
                console.log("=========> searchHomeCareGuideList resultData : ", resultData);
                if(resultData.resultCode === CODE.RCV_SUCCESS) {
                    // 사이즈체크는 기본 백단에서 해주고 넘기니 믿고 셋 처리
                    setHomeCareGuideList(resultData.result.homeCareGuideList);
                } else {
                    setHomeCareGuideList([]);
                }
                setIsLoading(false); // 로딩 완료
            })
            .catch((err) => {
                console.log("=========> err : ", err);
            });
    };

    useEffect(() => {

        if(isInitialRender.current) {
            searchHomeCareGuideList();
            isInitialRender.current = false;
        }
    }, []);


    const formatDate = (yyyymmdd) => {
        if (!yyyymmdd || yyyymmdd.length !== 8) return yyyymmdd;
        const yy = yyyymmdd.slice(2, 4);
        const mm = yyyymmdd.slice(4, 6);
        const dd = yyyymmdd.slice(6, 8);
        return `${yy}.${mm}.${dd}`;
    };


    const homeCareGuideTagSetting = () => {
        const tagList = [];
        let subList = [];
        let prevMasId = null;
        let prevBaseRgstDt = '';
        let prevHsptlNm = '';
        let prevDeptNm = '';

        homeCareGuideList.forEach((item, idx) => {
            const curMasId = item.cntsSndngMasId;

            // 첫 번째 그룹 초기화
            if (prevMasId === null) {
                prevMasId = curMasId;
                prevBaseRgstDt = item.baseRgstDt;
                prevHsptlNm = item.cnncHsptlNm;
                prevDeptNm = item.deptNm;
            }

            // 그룹이 변경되었을 때 이전 그룹 푸시
            if (prevMasId !== curMasId) {
                tagList.push(
                    <Accordion key={prevMasId} defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id={`panel-${prevMasId}`}>
                            <div className="accordion-head">
                                <p className="tit" data-status={getCalculateDDay(prevBaseRgstDt, 3) > 0 ? 'new' : ''}>
                                    {formatDate(prevBaseRgstDt)} 진료
                                </p>
                                <div className="sub-tit">
                                    <span>{prevHsptlNm}</span>
                                    <span>{prevDeptNm}</span>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="accordion-body">
                                <ul className={style['accordion-body-list']}>
                                    {subList}
                                </ul>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                );

                // 새로운 그룹값 초기화
                subList = [];
                prevMasId = curMasId;
                prevBaseRgstDt = item.baseRgstDt;
                prevHsptlNm = item.cnncHsptlNm;
                prevDeptNm = item.deptNm;
            }

            // 현재 아이템 추가
            subList.push(
                <li key={item.idx} data-icon={item.cntsSeCd === '01' ? 'mov' : 'txt'} data-status={item.cnfrmAt === '0' ? 'new' : ''}>
                    <button onClick={() => {
                        switch (item.cntsSeCd) {
                            case '01': navigate(URL.NOTICE_BOARD_MOVIE_DETAIL, { state: item }); break;
                            case '02': navigate(URL.NOTICE_BOARD_PDF_DETAIL, { state: item }); break;
                            case '03': navigate(URL.NOTICE_BOARD_SLIDE_DETAIL, { state: item }); break;
                            case '04': navigate(URL.NOTICE_BOARD_CARD_DETAIL, { state: item }); break;
                            default: break;
                        }
                    }}>
                        <span>{item.cntsSj}</span>
                    </button>
                </li>
            );

            // 마지막 아이템이면 마지막 그룹 추가
            if (idx === homeCareGuideList.length - 1) {
                tagList.push(
                    <Accordion key={curMasId} defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id={`panel-${curMasId}`}>
                            <div className="accordion-head">
                                <p className="tit" data-status={getCalculateDDay(prevBaseRgstDt, 3) > 0 ? 'new' : ''}>
                                    {formatDate(prevBaseRgstDt)} 진료
                                </p>
                                <div className="sub-tit">
                                    <span>{prevHsptlNm}</span>
                                    <span>{prevDeptNm}</span>
                                </div>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="accordion-body">
                                <ul className={style['accordion-body-list']}>
                                    {subList}
                                </ul>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                );
            }
        });

        return tagList;
    }

    return (
        <>
            <div id="medical-guide" className='inner-wrap'>
                <div className="top-banner-wrap">
                    <TopBannerBox type="typeB" />
                </div>


                <div className="accordion-wrap" data-type="a">


                    {/* 병원이 없을시 */}
                    {/* <div className={style['cont-box']}>
                        <div className={style['no-hospital-box']}>
                            < EmptyContentBox target="on" />
                        </div>
                    </div> */}


                    {/* 연결 병원이 있을시 */}
                    <div className={style['cont-box']}>

                         {/* 로딩 중일 때 스켈레톤 표시 */}
                        {isLoading && (
                            <>
                                {[...Array(5)].map((_, idx) => (
                                    <Accordion key={'skeleton_' + idx} defaultExpanded disabled>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <div className="accordion-head" style={{ width: '100%' }}>
                                                <p className="tit">
                                                    <Skeleton variant="text" width="200px" height={28}  />
                                                </p>
                                                
                                                <div className="sub-tit" style={{ display: 'flex', gap: '8px' }}>
                                                    <Skeleton variant="text" width="60px" height={22} />
                                                    <Skeleton variant="text" width="60px" height={22} />
                                                </div>
                                            </div>
                                        </AccordionSummary>
                                    </Accordion>
                                ))}
                            </>
                        )}


                        {/* no-data  */}
                        {!isLoading && homeCareGuideList?.length === 0 &&
                        <div className={style['no-data-box']}>
                            <div className={style['inner-box']}>
                                 <p>재택 치료 가이드가 없습니다.</p>
                            </div>
                        </div>
                        }

                        {!isLoading && homeCareGuideList?.length > 0 &&
                            homeCareGuideTagSetting()
                        }

                        {/*
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <div className="accordion-head">
                                    <p className="tit" data-status="new">
                                        24.12.22 진료
                                    </p>
                                    <div className="sub-tit">
                                        <span>여의도</span>
                                        <span>혈액내과</span>
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="accordion-body">
                                    <ul>
                                        <li data-icon="txt" data-status="new">
                                            <button>
                                                <span>의료진 안내사항</span>
                                            </button>
                                        </li>
                                        <li data-icon="txt" data-status="new">
                                            <button>
                                                <span>혈액암 수술 부위 관리 안내</span>
                                            </button>
                                        </li>
                                        <li data-icon="txt">
                                            <button>
                                                <span>혈액암 수술 후 추천 식단</span>
                                            </button>
                                        </li>
                                        <li data-icon="mov">
                                            <button onClick={()=> navigate(URL.NOTICE_BOARD_MOVIE_DETAIL)}>
                                                <span>복약 가이드</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <div className="accordion-head">
                                    <p className="tit">24.12.22 진료</p>
                                    <div className="sub-tit">
                                        <span>여의도</span>
                                        <span>혈액내과</span>
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="accordion-body">
                                    <ul>
                                        <li data-icon="txt" data-status="new">
                                            <button>
                                                <span>의료진 안내사항</span>
                                            </button>
                                        </li>
                                        <li data-icon="txt" data-status="new">
                                            <button>
                                                <span>혈액암 수술 부위 관리 안내</span>
                                            </button>
                                        </li>
                                        <li data-icon="txt">
                                            <button>
                                                <span>혈액암 수술 후 추천 식단</span>
                                            </button>
                                        </li>
                                        <li data-icon="mov">
                                            <button>
                                                <span>복약 가이드</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <div className="accordion-head">
                                    <p className="tit">24.12.22 진료</p>
                                    <div className="sub-tit">
                                        <span>여의도</span>
                                        <span>혈액내과</span>
                                    </div>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="accordion-body">
                                    <ul>
                                        <li data-icon="txt" data-status="new">
                                            <button>
                                                <span>의료진 안내사항</span>
                                            </button>
                                        </li>
                                        <li data-icon="txt" data-status="new">
                                            <button>
                                                <span>혈액암 수술 부위 관리 안내</span>
                                            </button>
                                        </li>
                                        <li data-icon="txt">
                                            <button>
                                                <span>혈액암 수술 후 추천 식단</span>
                                            </button>
                                        </li>
                                        <li data-icon="mov">
                                            <button>
                                                <span>복약 가이드</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        */}
                    </div>

                </div>
            </div>
        </>
    );
};

export default MedicalGuide;
